import React from 'react';
import { Button, Callout, Divider, InputGroup, Popover, Tooltip, Icon, IconSize, Toaster, Position } from "@blueprintjs/core";
import ActivityBarIcon from "../../components/ActivityBarIcon";
// import Logo from '../../images/logo.png';
import Logo from '../../images/logo.svg';
import  './activity-bar.css';
import EDialog from '../../components/EDialog';
import { useSelector, useDispatch } from 'react-redux';
import { makeAuthRequest } from '../../services/api';
import { attemptAuthentication, attemptGoogleAuthentication, logOutOfApp, acknowledgeSessionExpiry, markLoginAsFailed, clearAuthError } from '../session/session-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useVariant } from '../../hooks/useVariant';

const SessionToaster = Toaster.create({
    position: Position.TOP,
});

const ActivtyBar = (props) => {
   const { contributions, } = props.params;
   const variant = useVariant();
   const logoSrc = variant?.logoUrl || Logo;
   const [showSearch, setShowSearch] = React.useState(false);
   const [search, setSearch] = React.useState('');
   const [dialogDetails, setDialogDetails] = React.useState(null);
   const [showPassword, setShowPassword] = React.useState(false);
   const [loginEmail, setLoginEmail] = React.useState('');
   const [loginPassword, setLoginPassword] = React.useState('');
   const { authenticated, authenticating, userDetails, sessionExpired, loginError } = useSelector( state => state.session);
   const dispatch = useDispatch();

   const closeLoginDialog = React.useCallback(() => {
        if (authenticating) {
            // Clear stuck authenticating without showing an error (same as LoginForm)
            dispatch(markLoginAsFailed(""));
            setTimeout(() => dispatch(clearAuthError()), 0);
        }
        setDialogDetails(null);
        setShowPassword(false);
        setLoginEmail('');
        setLoginPassword('');
   }, [authenticating, dispatch]);

   const LOGIN_DIALOG = React.useMemo(() => ({
        title: 'Login',
        titleIcon: 'log-in',
        onClose: closeLoginDialog,
        body: <div>
            {loginError && <div style={{marginBottom: 10}}>
                <Callout intent="warning">{loginError}</Callout>
            </div>}
            <div style={{marginBottom: 10}}>
                <InputGroup type="text" placeholder="Username" icon='email'
                    value={loginEmail}
                    onChange={(e) => setLoginEmail(e.target.value)}
                />
            </div>
            <div style={{marginBottom: 10}}>
            <InputGroup
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                icon='lock'
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                rightElement={
                    <Button 
                        minimal={true} 
                        icon={showPassword ? "eye-off" : "eye-open"} 
                        onClick={() => setShowPassword(!showPassword)}
                    />
                }
            />
            </div>
            <div style={{marginTop: 15, marginBottom: 10, borderTop: '1px solid #eeeeee', paddingTop: 15}}>
                <Button 
                    text="Sign in with Google" 
                    icon={<FontAwesomeIcon icon={faGoogle} style={{marginRight: 8}} />}
                    intent="none"
                    disabled={authenticating}
                    onClick={() => {
                        dispatch(attemptGoogleAuthentication());
                    }}
                    fill
                    style={{
                        backgroundColor: '#fff', 
                        color: '#757575', 
                        border: '1px solid #dadce0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                />
            </div>
        </div>,
        actions: [
        <Button 
            key="cancel"
            text="Cancel" 
            onClick={closeLoginDialog}
            disabled={false}
        />,
        <Button 
            key="login"
            text={authenticating ? "Logging in..." : "Login"} 
            intent="primary" 
            onClick={() => {
                // Start authentication
                dispatch(attemptAuthentication({
                    email: loginEmail,
                    password: loginPassword,
                }));
            }} 
            disabled={authenticating}
        />
        ]
    }), [showPassword, dispatch, authenticating, loginEmail, loginPassword, loginError, closeLoginDialog]);


    const LOGOUT_DIALOG = React.useMemo(() => {
        const userName = userDetails?.first_name || 'User';
        return {
            title: 'Logout',
            titleIcon: 'log-out',
            onClose : () => setDialogDetails(null),
            body: <div>
                <div style={{marginBottom: 10}}>
                    <p>{userName}, are you sure you want to logout?</p>
                </div>
            </div>,
            actions: [
            <Button key="cancel" text="Cancel" onClick={() => {
                console.log('Cancel');
                setDialogDetails(null);
            }} />,
            <Button key="logout" text="Logout" intent="danger" onClick={() => {
                dispatch(logOutOfApp());
                setDialogDetails(null);
            }} />
            ]
        };
    }, [userDetails, dispatch]);

    // Close dialog on successful auth; otherwise keep dialog JSX in sync with state
    React.useEffect(() => {
        if (dialogDetails?.title !== 'Login') return;
        if (authenticated) {
            setDialogDetails(null);
            setShowPassword(false);
            setLoginEmail('');
            setLoginPassword('');
        } else {
            setDialogDetails(LOGIN_DIALOG);
        }
    }, [authenticated, showPassword, authenticating, loginEmail, loginPassword, loginError, LOGIN_DIALOG]);
    // Session expired (refresh token dead) — notify the user and prompt for login
    React.useEffect(() => {
        if (!sessionExpired) return;
        dispatch(acknowledgeSessionExpiry());
        SessionToaster.show({
            message: 'Your session has expired. Please log in again.',
            intent: 'warning',
            icon: 'time',
            timeout: 8000,
        });
        setShowPassword(false);
        setDialogDetails(LOGIN_DIALOG);
    }, [sessionExpired, dispatch]);

    // React.useState(() => {
    //     if(authenticating === false && authenticated === true) {
    //         setDialogDetails(null);
    //     }
    // }, [authenticating]);

    return (<div style={{
        flexDirection: 'column', 
        alignSelf:'stretch', 
        height: '95vh',
        display: 'flex'}}>

        <div style={{flex:1, overflowY: 'scroll'}} className="activity-extensions">
            <div style={{margin: 15, marginBottom: 20}}>
                <Tooltip content="Home">
                    {/* <Icon icon="home" size={24} intent="primary" /> */}
                    <img src={logoSrc} alt="Logo" width={30} height={30}  />
                </Tooltip>
            </div>
            <div style={{margin: 15, marginBottom: 20}} key="activityIcons">
                <Popover
                    content={<input type="search" 
                        placeholder="Search..." 
                        style={{width: 200, height: 30}}  
                        onChange={(e) => { 
                            setSearch(e.target.value);
                            if(globalThis.commands$['bss.aws:handle-command']) { 
                                globalThis.commands$['bss.aws:handle-command'].next(e.target.value);
                            }
                        }} value={search}/>}
                    // position="bottom"
                    placement="right"
                    isOpen={showSearch}
                    onClose={() => {
                        setShowSearch(false);
                    }}
                >
                <Tooltip content="Activity Bar Search">
                    <Icon icon={search ? "search-template" : "search"} size={24} intent="secondary" 
                        color={search ? "#2d72d2" : null}
                        onClick={() => {
                            setShowSearch(!showSearch);
                        }}
                    />
                </Tooltip>
                </Popover>
            </div>
            <div style={{margin: 15, marginBottom: 20}} key="extensions">
                <Tooltip content="Extensions">
                    <Icon icon="cube" size={24} intent="secondary" onClick={() => {
                        window['bodapro-context']?.setActivePanel('primary-sidebar');
                        window['bodapro-context']?.showSection('primary-sidebar');
                    }}/>
                </Tooltip>
            </div>
            {contributions.filter(v => {
            const p = new RegExp(search, 'gi');
            if (search === undefined) return true;
            if (search.length === 0) return true;
            if (p.test(v.name)) return true;
            return false;
            }).map((contribution, idx) => {
                return (<div style={{margin: 15, marginBottom: 20}} key={idx}>
                    <Tooltip content={contribution.label}>
                        <ActivityBarIcon icon={contribution.icon} size={24} onClick={() => { 
                            if(globalThis.commands$[contribution.id]) globalThis.commands$[contribution.id].next(contribution.name);
                        }}/>
                    </Tooltip>
                </div>);
            })}
            <div style={{margin: 15, marginBottom: 20}} key="subscription">
                <Tooltip content="Subscriptions">
                    <Icon icon="credit-card" size={24} intent="secondary" onClick={async () => {
                        // Check if user is logged in
                        if (!authenticated) {
                            setShowPassword(false); // Reset password visibility when opening dialog
                            setDialogDetails(LOGIN_DIALOG);
                            return;
                        }

                        const bodaproContext = window['bodapro-context'];
                        
                        // Ensure global registry exists
                        globalThis.executableCommands$ = globalThis.executableCommands$ || {};
                        
                        // Try to execute subscription.sidepanel command to open side panel
                        if (globalThis.executableCommands$['subscription.sidepanel']) {
                            try {
                                await bodaproContext?.executeCommand('subscription.sidepanel');
                                return;
                            } catch (error) {
                                console.error('Error executing subscription.sidepanel command:', error);
                            }
                        }
                        
                        // Fallback: directly add subscription side panel
                        if (bodaproContext?.addPanel) {
                            console.warn('subscription.sidepanel command not found, using direct addPanel fallback');
                            bodaproContext.addPanel({
                                id: 'bss.subscription',
                                title: 'Subscription',
                                icon: 'credit-card',
                                componentName: 'bss.subscription',
                                groupId: 'primary-sidebar',
                                replacePanel: true,
                            });
                            
                            // Show the primary sidebar
                            if (bodaproContext.showSection) {
                                bodaproContext.showSection('primary-sidebar');
                            } else if (bodaproContext.toggleSection) {
                                bodaproContext.toggleSection('primary-sidebar');
                            }
                        } else {
                            console.error('BodaProContext.addPanel not available');
                        }
                    }}/>
                </Tooltip>
            </div>
        </div>
        
        <div>
            <Divider />
            
            <div style={{margin: 15}}>
                <Tooltip content={authenticated ? userDetails.first_name : 'Account'}> 
                    <Icon 
                        icon={authenticated ? 'user' : 'lock'} size={24} 
                        intent="secondary" 
                        onClick={() => {
                        if(authenticated) {
                            setDialogDetails(LOGOUT_DIALOG);
                        }else{
                            setShowPassword(false); // Reset password visibility when opening dialog
                            setDialogDetails(LOGIN_DIALOG);
                        }
                       
                    }}/>
                </Tooltip>    
            </div>
            
            <div style={{margin: 15}}>
                <Tooltip content="Settings"> 
                    <Icon
                        icon="cog"
                        size={24}
                        intent="secondary"
                        onClick={() => {
                            const bodaproContext = window['bodapro-context'];
                            if (bodaproContext?.addPanel) {
                                bodaproContext.addPanel({
                                    id: 'settings-sidebar-panel',
                                    title: 'Settings',
                                    componentName: 'settingsSidebarPanel',
                                    groupId: 'primary-sidebar',
                                    replacePanel: true,
                                    params: {
                                        activeItem: 'profile',
                                    },
                                });
                            }
                        }}
                    />
                </Tooltip>
            </div>
            
        </div>

        {dialogDetails && <EDialog {...dialogDetails} />}
    </div>);
}

export default ActivtyBar